var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrap"},[_c('div',{staticClass:"order"},[_c('h2',[_vm._v(_vm._s(_vm.item.order))])]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"wrap"},[_c('h1',[_vm._v(_vm._s(_vm.item.instruction))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }